/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRequestAppointmentModalLoader_item = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRequestAppointmentModal_item">;
    readonly " $refType": "PdpRequestAppointmentModalLoader_item";
};
export type PdpRequestAppointmentModalLoader_item$data = PdpRequestAppointmentModalLoader_item;
export type PdpRequestAppointmentModalLoader_item$key = {
    readonly " $data"?: PdpRequestAppointmentModalLoader_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRequestAppointmentModalLoader_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRequestAppointmentModalLoader_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRequestAppointmentModal_item",
      "args": null
    }
  ]
};
(node as any).hash = '84aea6f3784648ec8b97d2c79cbb0dab';
export default node;
